import React from 'react';
import { Trash2 } from 'react-feather';
import moment from 'moment';
import RadioField from 'components/shared/RadioFieldGroup/RadioField';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';

const RecordingQuestionResponse = props => {
  const {
    userResponse,
    attemptIsCurrentChoice,
    handleOptionsChange,
    version,
    setUserResponseToDelete,
    finished,
    setSkipped,
  } = props;

  return (
    <div className="d-f fd-c m-fd-r m-jc-sb" key={userResponse.id}>
      <RadioField
        value={userResponse.givenAnswer}
        disabled={finished}
        className="QuestionElement--responseTab"
        checked={attemptIsCurrentChoice(userResponse)}
        onChange={e => {
          handleOptionsChange(e);
          setSkipped(false);
        }}
      >
        <div className="d-f fd-c m-mr-16">
          <div className="d-f fd-c">
            <Text variant={TEXT_VARIANTS.SUBHEADER}>
              {t('practice.repeatability.version')} {version}
            </Text>
            <Text variant={TEXT_VARIANTS.BODY_LIGHT}>
              {moment(userResponse.createdAt).format('MMM DD, YYYY')}
            </Text>
          </div>
        </div>
      </RadioField>
      <div className="m-d-f ml-20">
        <Trash2
          className="m-mt-4"
          size="17px"
          color="#3e3e47"
          onClick={() => setUserResponseToDelete(userResponse.id)}
          tabIndex="0"
          onKeyPress={e =>
            e.key === 'Enter' && setUserResponseToDelete(userResponse.id)
          }
        />
      </div>
    </div>
  );
};

export default RecordingQuestionResponse;
